import { useDispatch, useSelector } from "react-redux";
import { Icon } from "../core/icon";
import { useServices } from "../core-ui/ServiceProvider";
const dividerInstance = { divider: true };
const provide = (ipc) => {
    const { ChangeService, EditorsService, ProjectService, ResourceTreeService, WorkspaceService } = useServices();
    const dispatch = useDispatch();
    const project = useSelector(ProjectService.selectors.getProject);
    const projectFilePath = useSelector(ProjectService.selectors.getProjectFilePath);
    const focusedTab = useSelector(EditorsService.getFocusedTab);
    const focusedResourceID = focusedTab?.resource?.id;
    const nextUndo = useSelector((s) => ChangeService.getUndoSnapshot(s, focusedResourceID));
    const nextRedo = useSelector((s) => ChangeService.getRedoSnapshot(s, focusedResourceID));
    return [
        {
            id: 'file',
            label: 'File',
            menuItems: [
                { id: 'create-new-resource', label: 'Create New...', hotkey: 'Ctrl+Alt+N', run: () => dispatch(WorkspaceService.actions.openNewResourcePicker()) },
                { id: 'open-project', label: 'Open Project', hotkey: 'Ctrl+O', run: () => ipc.requestOpenProject() },
                { id: 'save-project', label: 'Save Project', hotkey: 'Ctrl+S', run: () => ipc.requestSave(project, projectFilePath) },
                dividerInstance,
                { id: 'quit', label: 'Quit', run: ipc.quit },
            ]
        },
        {
            id: 'edit',
            label: 'Edit',
            menuItems: [
                {
                    id: 'undo',
                    disabled: !Boolean(nextUndo),
                    label: nextUndo ? `Undo ${nextUndo.changeLabel}` : 'Undo',
                    icon: Icon.UNDO,
                    hotkey: "Ctrl+Z",
                    run: () => Boolean(nextUndo) && dispatch(ChangeService.undo(focusedResourceID)),
                },
                {
                    id: 'redo',
                    disabled: !Boolean(nextRedo),
                    label: nextRedo ? `Redo ${nextRedo.changeLabel}` : 'Redo',
                    icon: Icon.REDO,
                    hotkey: "Shift+Ctrl+Z",
                    run: () => Boolean(nextRedo) && dispatch(ChangeService.redo(focusedResourceID)),
                },
            ],
        },
        {
            id: 'view',
            label: 'View',
            menuItems: [
                { id: 'toggle-resource-tree', label: 'Toggle Resource Tree', hotkey: 'Ctrl+Y', run: () => dispatch(ResourceTreeService.actions.toggleVisible()) },
                { id: 'open-quicksearch', label: 'Open Quick Search', hotkey: 'Ctrl+E', run: () => dispatch(WorkspaceService.actions.toggleQuicksearch()) },
            ],
        },
        {
            id: 'help',
            label: 'Help',
            menuItems: [
                {
                    id: 'download-for-desktop',
                    label: 'Download for Desktop',
                    iconSuffix: Icon.EXTERNAL_LINK,
                    run: () => window.open('https://github.com/hexelate/releases/releases', '_blank')?.focus()
                },
                { id: 'about', label: 'About', run: dispatch.bind(null, EditorsService.open({ viewerID: 'core:about' })) },
            ]
        }
    ];
};
export default {
    provide,
};
//# sourceMappingURL=MenuProvider.js.map